<template>
  <el-container
    id="confirmacion"
    style="justify-content: center"
    v-loading.fullscreen.lock="loading"
  >
    <el-col
      class="main-wrapper"
      :xs="22"
      :sm="21"
      :md="14"
      :lg="12"
      :xl="12"
    >
      <el-row
        type="flex"
        justify="end"
        align="end"
      >
        <el-col
          :xs="24"
          :sm="12"
          :md="12"
          :lg="12"
          :xl="12"
          class="top-caption"
        >
          <p class="payment">
            PAGO DEL IMPUESTO PREDIAL EN LÍNEA
          </p>
          <p class="thanks" v-if="params.success">
            Gracias por realizar su pago
          </p>
        </el-col>
      </el-row>
      <br>
      <br>
      <el-row
        type="flex" justify="center"
      >
        <el-col v-if="params.success" class="col-flex-center">
          <p class="caption">
            {{ params.nbResponse }}
          </p>
          <i class="el-icon-success" />
          <b><p>Operación realizada con éxito</p></b>
        </el-col>
        <el-col v-else class="col-flex-center">
          <p class="caption">
            {{ params.nbResponse }}
          </p>
          <br>
          <i class="el-icon-error" />
          <br>
          <b><p>{{ params.cdResponse }}</p></b>
          <p>{{ params.nb_error }}</p>
        </el-col>
      </el-row>
      <br>
      <el-row
        type="flex" justify="center"
        v-if="params.success"
      >
        <el-col
          :xs="16"
          :sm="10"
          :md="10"
          :lg="10"
          :xl="10"
          class="col-24-on-xs"
        >
          <el-row type="flex" justify="center">
            <el-col>
              <b><p>Operacion:</p></b>
            </el-col>
            <el-col style="text-align: end">
              <p>{{ params.operacion }}</p>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col>
              <b><p>Referencia:</p></b>
            </el-col>
            <el-col style="text-align: end">
              <p>{{ params.referencia }}</p>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col>
              <b><p>Total:</p></b>
            </el-col>
            <el-col style="text-align: end">
              <p>{{ $currencyFormater(params.importe) }}</p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <br>
      <br>
      <el-row
        type="flex" justify="center"
        class="hide-on-print"
      >
        <el-col
          :md="8"
          :sm="12"
        >
          <p style="text-align: center; font-size: 14px">
            <b>Volver a página de inicio</b>
          </p>
          <br>
          <el-button :loading="loading" class="back-btn">
            <router-link to="/busqueda-del-predio">
              Salir
            </router-link>
          </el-button>
        </el-col>
      </el-row>
      <br>
      <el-row
        type="flex" justify="center"
        class="hide-on-print"
        v-if="params.success"
      >
        <el-col
          :md="8"
          :sm="12"
        >
          <el-button
            :loading="loading"
            @click="getRecibo"
            style="width: 100%;
              background-color: rgb(185, 165, 203);
              color: #FFFFFF;"
          >
            Imprimir recibo
          </el-button>
          <a
            v-if="!$isWebView()"
            id="btnEncuesta"
            class="el-button el-button--primary"
            style="width: 100%;
              background-color: rgb(185, 165, 203);
              color: #FFFFFF; margin-left: 0; margin-top: 5px; text-decoration: none;
              border: none;"
            tag="a"
            href="https://portal.zapopan.gob.mx/Encuestas/Encuesta2022.asp"
            target="_blank"
          >
            Llenar encuesta
          </a>
        </el-col>
      </el-row>
      <br>
      <el-row type="flex" justify="center">
        <el-col
          :sm="16" :md="14"
          style="text-align:center; font-size: 11px"
        >
          <p>
            DIRECCIÓN DE INGRESOS
          </p>
          <p>
            UNIDAD ADMINISTRATIVA BASÍLICA, 2DO NIVEL, OFICINA 22
          </p>
          <p>
            CENTROHISTÓRICO, ZAPOPAN JALISCO
          </p>
          <p>
            38182200 EXT. 2060, 2061, 2055
          </p>
        </el-col>
      </el-row>
    </el-col>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      params: {},
      loading: false,
      counter: 0,
    };
  },
  methods: {
    async getRecibo() {
      try {
        this.loading = true;
        const { referencia } = this.params;
        const esCNA = referencia?.toUpperCase().startsWith('CNA');

        if (esCNA) {
          // Las referencias CNA no pasan por WPP/Santander sino por Adquira/Bancomer,
          // por lo que /WPP/IntercambiarReferencia siempre devuelve 404 para ellas.
          // El ID está embebido en la referencia: CNA{id}{DDMMYYYYss} → slice(3, -10)
          const id = referencia.slice(3, -10);
          const resRecibo = await this.axios.get(`/InformacionReciboCNA/${id}`);
          const reciboPDF = resRecibo.data.recibo;
          this.$store.dispatch('receipt/SET_DATA', { tipo: 'certificado-no-adeudos', reciboPDF });
          this.loading = false;
          this.$router.push({ path: 'recibo-pdf' });
          return;
        }

        const response = await this.axios.get(`/WPP/IntercambiarReferencia/${referencia}`);
        const { data } = response;
        const regex = new RegExp(/pago realizado/, 'i');
        if (regex.test(data.message)) {
          const { cuentaPredial, curt, claveCatastral } = data;
          const param = cuentaPredial || curt || claveCatastral;
          const resRecibo = await this.axios.get(`/InformacionRecibo/${param}`);
          const reciboPDF = resRecibo.data.recibo;
          this.$store.dispatch('receipt/SET_DATA', {
            tipo: 'pago-predial',
            reciboPDF,
          });
          this.loading = false;
          this.$router.push({ path: 'recibo-pdf' });
        } else {
          this.$ErrorNotify({
            response: {
              data: {
                alerta: data.message,
              },
            },
          });
        }
      } catch (err) {
        // throw new Error('{ "response": { "status": 404 } }');
        // eslint-disable-next-line no-ex-assign
        // err = JSON.parse(err.message);
        if (err?.response?.status === 404) {
          if (this.counter < 40) {
            this.counter++;
            setTimeout(this.getRecibo, 15000);
          } else {
            this.$ErrorNotify({
              response: {
                data: {
                  alerta: 'Ha ocurrido un error generando el recibo, por favor intentelo más tarde.',
                },
              },
            });
            this.loading = false;
          }
        } else {
          this.$ErrorNotify(err);
          this.loading = false;
        }
      }
    },
  },
  mounted() {
    const params = this.$route.query;
    console.log(params);
    const regex = new RegExp(/aprobado|approved/, 'i');
    params.success = regex.test(params.nbResponse);
    this.params = params;
    setTimeout(() => {
      document.querySelector('#btnEncuesta')?.click();
    }, 500);
  },
};
</script>

<style lang="scss" scoped>
  .main-wrapper {
    padding: 40px 0;
    .back-btn {
      width: 100%;
      & a {
        text-decoration: none !important;
        color: #000000 !important;
      }
    }
    .top-caption {
      .payment {
        text-align: center;
        font-size: 16pt;
        font-weight: bold;
      }
      .thanks {
        font-size: 14pt;
        font-weight: bold;
        color: #ffffff;
        background-color: #C9237E;
        padding: 10px;
      }
    }

    .col-flex-center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .caption {
      text-align: center;
      font-weight: bold;
      font-size: 18px;
    }
    .el-icon-error, .el-icon-success {
      font-size: 120px;
    }

    .el-icon-success {
      color: #4BB543;
    }

    .el-icon-error {
      color: #CC3300;
    }
  }

  @media only screen and (max-width: 450px) {
    .col-24-on-xs {
      width: 100% !important;
    }
  }
</style>

<style>
@media print {
  .header, .hide-on-print {
    display: none;
  }
}
</style>
